<template >
    <header-layout :user="user">
        <template #left_section>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'diy-dashboard'}"
                    class="nav-link d-flex align-items-center px-1" target="_self"
                >
                    <vue-feather class="mr-20" type="home" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('Dashboard') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'credit-report'}"
                    class="nav-link d-flex align-items-center px-1" target="_self"
                >
                    <vue-feather class="mr-20" type="clipboard" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('Diy Credit Report') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <a
                    href="#"
                    data-toggle="modal"
                    data-target="#credit_analysis_modal_update"
                    class="nav-link d-flex align-items-center  px-1"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="bar-chart" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('credit.analysis') }}</span>
                </a>
            </li>
            <!-- <li class="nav-item">
                <router-link
                    :to="{ name: 'thirty-day-report'}"
                    class="nav-link d-flex align-items-center px-1"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="airplay" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('thirty.day.report') }}</span>
                </router-link>
            </li> -->
            <li class="nav-item">
                <router-link
                    :to="{ name: 'dispute-report'}"
                    class="nav-link d-flex align-items-center px-1"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="layers" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('Dispute Letters') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'authorized-user'}"
                    class="nav-link d-flex align-items-center px-1"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="credit-card" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('user.authorized.user') }}</span>
                </router-link>
            </li>
            <li class="nav-item">
                <router-link
                    :to="{ name: 'chat-index'}"
                    class="nav-link d-flex align-items-center px-1"
                    target="_self"
                >
                    <vue-feather class="mr-20" type="message-square" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('chat.navbar.title') }}</span>
                </router-link>
            </li>
            <li class="dropdown nav-item sidebar-group-active open">
                <a href="#" target="_self"
                    class="dropdown-toggle d-flex align-items-center" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
                    >
                    <vue-feather class="mr-20" type="book-open" size="15"></vue-feather>
                    <span>{{ localizationStore.translate('education') }}</span></a>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li class="dropdown-item">
                        <router-link
                            :to="{ name: 'academy'}"
                            class="nav-link d-flex align-items-center justify-content-start text-primary" target="_self"
                        >
                            <vue-feather class="mr-20" type="monitor" size="15"></vue-feather>
                            <span>Dashboard</span>
                        </router-link>
                    </li>
                    <li class="dropdown-item">
                        <router-link
                            :to="{ name: 'courses'}"
                            class="nav-link d-flex align-items-center justify-content-start text-primary" target="_self"
                        >
                            <vue-feather class="mr-20" type="monitor" size="15"></vue-feather>
                            <span>{{ localizationStore.translate('education.courses') }}</span>
                        </router-link>
                    </li>
                    <li class="dropdown-item">
                        <router-link
                            :to="{ name: 'user-courses'}"
                            class="nav-link d-flex align-items-center px-50 text-primary" target="_self"
                        >
                            <vue-feather class="mr-20" type="archive" size="15"></vue-feather>
                            <span>{{ localizationStore.translate('education.user.courses') }}</span>
                        </router-link>
                    </li>

                </ul>
            </li>
        </template>
    </header-layout>
    <diy-navbar :user="user"></diy-navbar>
</template>
<script>
import { ref } from 'vue'
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useSettingStore } from '../../../stores/SettingStore.js'
import HeaderLayout from './layouts/HeaderLayout'
import DiyNavbar from './DiyNavbar.vue'
export default {
    components:{
        HeaderLayout,DiyNavbar
    },
    props:{
        user:{
            type:[Array,Object]
        },
    },
    setup(props){
        const localizationStore = useLocalizationStore();
        const settingStore = useSettingStore();
        return{
            localizationStore,settingStore
        }
    },
    created(){
    },

}
</script>

